import React, { useContext, useState } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './app/x/App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route, Outlet, Link } from 'react-router';
import FirebaseCrud from './firebase-crud';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import DashboardIcon from '@mui/icons-material/Dashboard';
import RequestQuote from '@mui/icons-material/RequestQuote';
import Handyman from '@mui/icons-material/Handyman';
import DescriptionIcon from '@mui/icons-material/Description';
import LayersIcon from '@mui/icons-material/Layers';
import { DashboardLayout } from '@toolpad/core/DashboardLayout';
import { FirebaseProvider, useFirebase } from './firebase-context';
import AppContext from './app-context';
import AppUnauthed from './app-unauthed';
import cruddefs from './firebase-crud/crud-defs';
import { ref, get, onChildChanged } from 'firebase/database';
import EditItem from './firebase-crud/edit-item';
import { ReactRouterAppProvider } from '@toolpad/core/react-router';
import MenuItem from '@mui/material/MenuItem';
import { getAuth, signOut } from 'firebase/auth';
import StarterComponent from './app/starter-component';

const theme = createTheme({
  palette: {
    primary: {
      light: '#fff',
      main: '#ed873f',
      dark: '#b4805c',
      contrastText: '#545454',
    },
    secondary: {
      light: '#ff7961',
      main: '#5393ff',
      dark: '#ba000d',
      contrastText: '#000',
    },
    mono: {
      light: '#545454',
      main: '#fff',
      dark: '#b4805c',
      contrastText: '#fff',
    }
  },
});

const NAVIGATION = [
  {
    kind: 'header',
    title: 'Job Management',
  },
  {
    title: 'Projects',
    segment: 'projects',
    icon: <Handyman />,
  },
  ...Object.values(cruddefs).map((def) => ({
    pattern: `${def.storageKey}{/:recId}*`,
    title: `${def.crudLabel}s`,
    segment: def.storageKey,
    icon: def.icon || <RequestQuote />
  }))
];

const container = document.getElementById('root');
const root = createRoot(container);

const AuthGate = ({ children, appContextValue }) => {
  const { db, user } = useFirebase();

  const { setAccessLevel, accessLevel } = appContextValue;

  if (user) {
    get(ref(db, `/users/${user.uid}`))
        .then((snapshot) => {
          if (snapshot.exists()) {
            setAccessLevel(snapshot.val());
          } else {
            setAccessLevel(0);
          }
        });
  }
  // thought: show a loading spinner while Firebase is initializing
  if (!user || accessLevel === null) return <AppUnauthed />;

  return (
    <AppContext.Provider value={appContextValue}>
      {user ? children : <AppUnauthed />}
    </AppContext.Provider>
  );
};

async function googleSignout() {
    await signOut(getAuth());
}

const HomePage = () => (
  <div>Home Content</div>
);

const Root = () => {
  const [accessLevel, setAccessLevel] = useState(-2);

  const appContextValue = {
    accessLevel,
    setAccessLevel,
  };

  return (
      <ReactRouterAppProvider navigation={NAVIGATION}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <FirebaseProvider>
            <AuthGate appContextValue={appContextValue}>
              <DashboardLayout
                branding={{
                  logo: <img src="/logo.png" alt="CrateAndTools" />,
                  title: 'Job Portal',
                  homeUrl: '/',
                }}
              >
                <MenuItem key="abc" onClick={googleSignout}>
                  Logout
                </MenuItem>
                <Routes>
                    {
                      Object.keys(cruddefs).map((key) => (
                        <Route key={key} path={ cruddefs[key].storageKey } element={<FirebaseCrud definition={key} />}>
                          <Route path=":id" element={<FirebaseCrud definition={key} />} />
                        </Route>
                      ))
                    }
                    <Route path="projects" element={ <StarterComponent /> } />
                    <Route index element={<HomePage />} />
                </Routes>
                <Outlet />
              </DashboardLayout>
            </AuthGate>
          </FirebaseProvider>
        </LocalizationProvider>
      </ReactRouterAppProvider>
  );
};

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Root />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

